import {
	type OrderPaymentCreateDto,
	patchOrdersOrderIdPaymentsPaymentId,
} from "Infrastructure/Api/Api";
import {
	getMessageFromErrorResponse,
	processResponse,
} from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { getOrderChargesSumQueryKey } from "Order/Modules/Payment/Api/Query/useOrderChargesSumQuery";
import { getOrderFeeQueryKey } from "Order/Modules/Payment/Api/Query/useOrderFeeQuery";
import { getOrderPaymentDetailQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentDetailQuery";
import { getOrderPaymentListQueryKey } from "Order/Modules/Payment/Api/Query/useOrderPaymentListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useUpdateOrderPaymentMutation = (
	orderId: number,
	paymentId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderPaymentCreateDto) =>
			patchOrdersOrderIdPaymentsPaymentId(data, orderId, paymentId),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.updatePaymentError)}:`,
				error,
			);
			// Extract the actual error message from the API response
			const errorMessage =
				getMessageFromErrorResponse(error) ||
				t(paymentMutationsResource.updatePaymentError);
			toast.error(errorMessage);
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.updatePaymentSuccess));
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentListQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderChargesSumQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderPaymentDetailQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderFeeQueryKey(orderId),
			});
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
		},
	});
};
